angular.module('sd')

.constant('ENV', {APIIP:'https://api.startdate.ca/'})

;